import { formatReadingTime } from '@/utils/readingTime'
import { CustomColumnGridConfig } from '../types'

// The grid filters only the rows of the current page, so a server-paged
// report offers no column filter.
const column = (field: string, headerName: string): CustomColumnGridConfig => ({
  field,
  headerName,
  width: 150,
  minWidth: 120,
  flex: 1,
  filterSpec: { kind: 'none' },
  filterable: false,
  hideable: true,
  disableAggregation: true,
})

const detailedReadingsColumns: CustomColumnGridConfig[] = [
  column('meterNumber', "מס' מד"),
  column('billingId', 'מספר כרטיס מים'),
  column('name', 'שם'),
  column('address', 'כתובת'),
  {
    ...column('readingAt', 'תאריך קריאה'),
    width: 170,
    format: value => ({
      kind: 'text',
      text: typeof value === 'string' ? formatReadingTime(value) : '-',
    }),
    // In a right-to-left cell the date and the time are two left-to-right runs,
    // so the browser paints the time left of the date. Isolating the display
    // keeps the text, and so copied and exported values, unchanged.
    renderCell: ({ formattedValue }) => <bdi dir="ltr">{formattedValue}</bdi>,
  },
  column('reading', 'קריאה'),
]

export default detailedReadingsColumns
